export const homeObjOne = {
  primary: true,
  lightBg: false,
  lightTopLine: true,
  lightText: true,
  lightTextDesc: true,
  topLine: 'KARE OSS',
  headline: 'Debug Engineers Liberally',
  description:
    'Kare oss is going to be the india biggest open source society. we organize live events regarding skill development, live projects and research oriented  ',
  buttonLabel: 'Get Started',
  imgStart: '',
  img: require('../../images/image.png'),
  alt: 'Credit Card',
  start: ''
};



export const homeObjThree = {
  primary: false,
  lightBg: true,
  lightTopLine: false,
  lightText: false,
  lightTextDesc: false,
  topLine: 'Kare clubs',
  headline:
    'To acquire knowledge,one must study',
  description:
    "Join a club of your choice for the exclusive events, weekly meetings and get mentorship from the experts.",
  buttonLabel: 'Join Now',
  imgStart: 'start',
  img: require('../../images/events.png'),
  alt: 'Vault',
  start: 'true'
};

